const DEV_MEETING_OWL_PRO_BUNDLE = 38477434093737;
const DEV_MEETING_OWL_PRO_BUNDLE_GHOST = 41467131691177;
const DEV_MEETING_OWL_PRO = 38477375078569;
const DEV_USB_CABLE_EXTENSION = 38477471088809;
const DEV_LOCK_ADAPTER = 38477407682729;
const DEV_OWL_CARE = 38477398147241;

const UK_MEETING_OWL_PRO_BUNDLE = 29197343785044;
const UK_MEETING_OWL_PRO_BUNDLE_GHOST = 40668083945669;
const UK_MEETING_OWL_PRO = 28720834150484;
const UK_USB_CABLE_EXTENSION = 32443289567316;
const UK_LOCK_ADAPTER = 28235463852116;
const UK_OWL_CARE = 28235055890516;

const CA_MEETING_OWL_PRO_BUNDLE = 29506881388588;
const CA_MEETING_OWL_PRO_BUNDLE_GHOST = 41103735718066;
const CA_MEETING_OWL_PRO = 29419857707052;
const CA_USB_CABLE_EXTENSION = 10348318392364;
const CA_LOCK_ADAPTER = 10618453852204;
const CA_OWL_CARE = 10348337332268;

const US_MEETING_OWL_PRO_BUNDLE = 21267338461243;
const US_MEETING_OWL_PRO_BUNDLE_GHOST = 39610618675259;
const US_MEETING_OWL_PRO = 31046615793723;
const US_USB_CABLE_EXTENSION = 12851573063739;
const US_LOCK_ADAPTER = 13033281781819;
const US_OWL_CARE = 12851539378235;

export default {
  'owl-labs.myshopify.com': [
    {
      name: 'Premium Pack: Meeting Owl Pro',
      variant_id: US_MEETING_OWL_PRO_BUNDLE,
      items: [
        { quantity: 1, variant_id: US_MEETING_OWL_PRO_BUNDLE_GHOST, discount_per: 0 },
        { quantity: 1, variant_id: US_MEETING_OWL_PRO, discount_per: 325 },
        { quantity: 1, variant_id: US_USB_CABLE_EXTENSION, discount_per: 325 },
        { quantity: 1, variant_id: US_LOCK_ADAPTER, discount_per: 325 },
        { quantity: 1, variant_id: US_OWL_CARE, discount_per: 325 },
      ],
    },
  ],
  'owl-labs-uk.myshopify.com': [
    {
      name: 'Premium Pack: Meeting Owl Pro',
      variant_id: UK_MEETING_OWL_PRO_BUNDLE,
      items: [
        { quantity: 1, variant_id: UK_MEETING_OWL_PRO_BUNDLE_GHOST, discount_per: 0 },
        { quantity: 1, variant_id: UK_MEETING_OWL_PRO, discount_per: 325 },
        { quantity: 1, variant_id: UK_USB_CABLE_EXTENSION, discount_per: 325 },
        { quantity: 1, variant_id: UK_LOCK_ADAPTER, discount_per: 325 },
        { quantity: 1, variant_id: UK_OWL_CARE, discount_per: 325 },
      ],
    },
  ],
  'owl-labs-ca.myshopify.com': [
    {
      name: 'Premium Pack: Meeting Owl Pro',
      variant_id: CA_MEETING_OWL_PRO_BUNDLE,
      items: [
        { quantity: 1, variant_id: CA_MEETING_OWL_PRO_BUNDLE_GHOST, discount_per: 0 },
        { quantity: 1, variant_id: CA_MEETING_OWL_PRO, discount_per: 325 },
        { quantity: 1, variant_id: CA_USB_CABLE_EXTENSION, discount_per: 325 },
        { quantity: 1, variant_id: CA_LOCK_ADAPTER, discount_per: 325 },
        { quantity: 1, variant_id: CA_OWL_CARE, discount_per: 325 },
      ],
    },
  ],
  'owl-labs-development.myshopify.com': [
    {
      name: 'Premium Pack: Meeting Owl Pro',
      variant_id: DEV_MEETING_OWL_PRO_BUNDLE,
      items: [
        { quantity: 1, variant_id: DEV_MEETING_OWL_PRO_BUNDLE_GHOST, discount_per: 0 },
        { quantity: 1, variant_id: DEV_MEETING_OWL_PRO, discount_per: 325 },
        { quantity: 1, variant_id: DEV_USB_CABLE_EXTENSION, discount_per: 325 },
        { quantity: 1, variant_id: DEV_LOCK_ADAPTER, discount_per: 325 },
        { quantity: 1, variant_id: DEV_OWL_CARE, discount_per: 325 },
      ],
    },
  ],
};
